import Config from '@/config';
import {
  ProtocolListResult,
  ProtocolDetailResult,
} from '@/types/api/protocol';
import http, { HttpPromise } from './http';

const list = (role: string, params?: ProtocolListResult): HttpPromise<ProtocolListResult> => http.get<ProtocolListResult>(`${Config.apiHost}/${role}/protocol/list/`, { params });
const detail = (role: string, params: { id: number }): HttpPromise<ProtocolDetailResult> => http.get<ProtocolDetailResult>(`${Config.apiHost}/${role}/protocol/detail/`, { params });
const accept = (role: string, params: { id: number }): HttpPromise<ProtocolDetailResult> => http.post<ProtocolDetailResult>(`${Config.apiHost}/${role}/protocol/changeStatusOnApproval/`, { ...params });
const reject = (role: string, params: { id: number }): HttpPromise<ProtocolDetailResult> => http.post<ProtocolDetailResult>(`${Config.apiHost}/${role}/protocol/changeStatusOnRejection/`, { ...params });

export default {
  supplier: {
    list: list.bind(this, 'supplier'),
    detail: detail.bind(this, 'supplier'),
    accept: accept.bind(this, 'supplier'),
    reject: reject.bind(this, 'supplier'),
  },
};
